import * as React from 'react';

import { CardActionsLayout } from '../../components/CardActionsLayout';
import { PhoneButtonContainer } from '../PhoneButtonContainer';
import { ChatButtonContainer } from '../ChatButtonContainer';
import { ContactsPopupContainer } from '../ContactsPopupContainer';
import { selectRecommendationById } from '../../selectors/recommendations/selectRecommendationById';
import { useSelector } from 'react-redux';

interface IProps {
  offerId: number;
}

export function CardActionsContainer({ offerId }: IProps): React.JSX.Element {
  const offer = useSelector(selectRecommendationById(offerId));
  const { author } = offer;
  const isLeadFactory = Boolean(author?.isFromLeadFactory);

  const [isContactsPopupOpened, setIsContactsPopupOpened] = React.useState(false);

  const onPhoneButtonClick = React.useCallback(() => {
    if (!isLeadFactory) {
      return;
    }

    setIsContactsPopupOpened(true);
  }, [isLeadFactory]);

  const onCloseContactsPopup = React.useCallback(() => {
    setIsContactsPopupOpened(false);
  }, []);

  return (
    <>
      <CardActionsLayout>
        <PhoneButtonContainer offerId={offerId} onClick={onPhoneButtonClick} />
        <ChatButtonContainer offerId={offerId} />
      </CardActionsLayout>
      <ContactsPopupContainer isOpen={isContactsPopupOpened} offerId={offerId} onClose={onCloseContactsPopup} />
    </>
  );
}
